/** Sound is local UI state (`useV2Ui.soundOn`); `rail/useSounds` reads it. */
import {useCallback} from 'react';

import {useV2Ui} from '../../../../theme/useV2Ui';

export type SoundTileModel = {
  soundOn: boolean;
  onPress: () => void;
};

export function useSoundTileModel(): SoundTileModel {
  const soundOn = useV2Ui(s => s.soundOn);
  const setSoundOn = useV2Ui(s => s.setSoundOn);
  const onPress = useCallback(
    () => setSoundOn(!soundOn),
    [soundOn, setSoundOn],
  );
  return {soundOn, onPress};
}
